module.exports = __webpack_public_path__ + "img/247.jpg.5f881a68.webp";